import React from 'react';
import { useHistory } from 'react-router';
import { withStyles, useMediaQuery, useTheme } from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import { OverviewGridItem } from 'views/PublicRoutes/Dashboard/Home/Overview/components/OverviewGridItem';
import ProgressButton from '../ProgressButton';
import styles from './style';
import Box from '../atomic/Box';
import Grid from '../atomic/Grid';
import Image from '../Image/index';
import Typography from '../atomic/Typography';
import WomenPhone from '../../assets/images/Woman_Phone.png';

const PurchasingInsuranceCTA = ({ classes, setShowInsuranceCTA }) => {
  const history = useHistory();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <OverviewGridItem showMaxwidth>
      <Box
        className={classes.content}
        style={{ margin: isSmallScreen && '10px' }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className={classes.textArea}
            style={{ order: isSmallScreen ? 2 : 1 }}
          >
            <Typography mt={0} variant="h2" className={classes.title}>
              Du har en jobb som kan forsikres med Trygt utført.
            </Typography>
            <Typography
              style={{ marginBottom: '18px' }}
              className={classes.text}
            >
              Visste du at 1 av 6 opplever uenighet med håndverkeren?
            </Typography>

            <Typography className={classes.text}>
              Trygt utført er Boligmappas advokatforsikring for
              håndverkertjenester - til kun kr 990!
            </Typography>

            <Box className={classes.btnContent}>
              <ProgressButton
                color="primary"
                variant="contained"
                onClick={() => {
                  history.push('/insurance');
                }}
                className={classes.button}
              >
                Lær mer
              </ProgressButton>
              <ProgressButton
                className={classes.buttonRg}
                variant="contained"
                onClick={() => {
                  setShowInsuranceCTA(false);
                }}
              >
                Nei, takk
              </ProgressButton>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ display: 'flex', order: isSmallScreen ? 1 : 2 }}
            className={classes.imageBox}
          >
            <Image
              className={classes.image}
              style={{ margin: isSmallScreen ? 'auto' : '0' }}
              fallbackSrc={WomenPhone}
            />
          </Grid>
        </Grid>
      </Box>
    </OverviewGridItem>
  );
};

export default withStyles(styles)(PurchasingInsuranceCTA);
